import React, { ReactNode } from 'react'

interface ContainerProps {
  children: ReactNode,
}
export default ({ children }: ContainerProps) => (
  <div className="tw-container tw-grid tw-grid-cols-12 tw-mx-auto tw-px-4">
    {children}
  </div>
)
